import moment from 'moment';
import AbstractFieldsValidator from 'components/helpers/validation/AbstractFieldsValidator';
import validateEmail from 'components/helpers/validation/validateEmail';
import validatePassword from 'components/helpers/validation/validatePassword';
import {isValidNumber} from 'libphonenumber-js';

export default function (fields, options) {
    return new DoctorFieldsValidator(fields, options).validate();
}

class DoctorFieldsValidator extends AbstractFieldsValidator {
    doCheckForSingleValue() {
        const {
            firstName, lastName, gender,
            birthDate, phoneNumber, timezone,
            acceptPrivacyPolicy,
            acceptTerms,
            acceptPrescriptionPolicy,
        } = this.fields;
        if (!acceptPrivacyPolicy) {
            this.addError('acceptPrivacyPolicy', loc('accept-privacy-invalid'));
        }
        if (!acceptTerms) {
            this.addError('acceptTerms', loc('accept-terms-invalid'));
        }
        if (!acceptPrescriptionPolicy) {
            this.addError('acceptPrescriptionPolicy', loc('accept-prescription-policy-invalid'));
        }
        if (!firstName || !firstName.trim()) {
            this.addError('firstName', loc('first-name-empty'));
        } else if (firstName.length > 35) {
            this.addError('firstName', loc('max-length-firstName'));
        }
        if (!lastName || !lastName.trim()) {
            this.addError('lastName', loc('last-name-empty'));
        } else if (lastName.length > 35) {
            this.addError('lastName', loc('max-length-lastName'));
        }
        if (!gender) this.addError('gender', loc('gender-empty'));
        if (!birthDate || !birthDate.isValid()) {
            this.addError('birthDate', loc('birthDate-empty'));
        } else {
            const minDate = moment("01.01.1900", "DD.MM.YYYY");
            if (moment().isBefore(birthDate)) {
                this.addError('birthDate', loc('birthDate-max-invalid'))
            }
            if (minDate.isAfter(birthDate)) {
                this.addError('birthDate', loc('birthDate-min-invalid'))
            }
        };
        if (!phoneNumber || !phoneNumber.trim()) this.addError('phoneNumber', loc('phone-number-empty'));
        if (!isValidNumber(phoneNumber) && !isValidNumber(phoneNumber, 'US')) this.addError('phoneNumber', loc('phone-number-invalid'));
        if (!timezone) {
            this.addError('timezone', loc('timezone-empty'));
        }


        const {
            password, confirmPassword, email
        } = this.fields;

        if (!email.trim()) this.addError('email', 'Please enter email');

        if (!validateEmail(email.trim())) this.addError('email', 'Please enter a valid email');

        const passwordError = validatePassword(password);
        if (passwordError) this.addError('password', passwordError);

        if (!confirmPassword.trim()) this.addError('confirmPassword', 'Please repeat your password');
    }

    doCheckForRelations() {
        const {password, confirmPassword} = this.fields;

        if (password !== confirmPassword) this.addError('confirmPassword', 'Passwords do not match');
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/validatePatientFields.js